import localeData from '@wix/locale-dataset-javascript';

export interface CurrencyOption {
  id: string;
  symbol: string;
  label: string;
}

const unsupportedCurrencies = ({ key }: { key: string }) =>
  ['MZM', 'ROL', 'TMM', 'ZMK', 'BGL', 'GHC'].indexOf(key) === -1;

export const getTranslatedCurrencyOptions = (
  translations: Record<string, string>,
  sortField: keyof CurrencyOption = 'label',
): Array<CurrencyOption> => {
  return localeData
    .getAllCurrencies()
    .filter(unsupportedCurrencies)
    .map(({ key, displayName, symbol }) => {
      const translatedDisplayName = translations?.[displayName];
      return {
        id: key,
        symbol,
        label: `${translatedDisplayName} - ${key} (${symbol})`,
      };
    })
    .sort((a, b) => a[sortField].localeCompare(b[sortField]));
};

export const getCurrencySymbolWithISO = (currencyISO: string) => {
  const currencies = localeData.getAllCurrencies();
  const currency = currencies.find((option) => option.key === currencyISO);
  return `${currency?.symbol} ${currency?.key}`;
};
